import { useId } from 'react'
import type { ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './RadioCards.css'

export interface RadioCardOption {
  id: string
  label: ReactNode
}

export interface RadioCardsProps {
  label: ReactNode
  /** "· lo exige el registro oficial" */
  labelNote?: ReactNode
  options: RadioCardOption[]
  value: string | null
  onChange: (id: string) => void
  /** 1 = lista (canal del enlace, 56 px); 2 = en fila (sexo, 52 px) */
  columns?: 1 | 2
  error?: ReactNode
  name?: string
  className?: string
}

/**
 * Lista de radio en tarjetas (bundle B2: "¿Cómo le enviamos el enlace?" y "Sexo"): radio visible de 24 px,
 * seleccionado con borde --primary y fondo primary-soft. Radio group nativo.
 */
export function RadioCards({ label, labelNote, options, value, onChange, columns = 1, error, name, className }: RadioCardsProps) {
  const uid = useId()
  const groupName = name ?? `hp-radio-${uid}`
  const errorId = `${groupName}-error`
  return (
    <fieldset className={cx('hp-radiocards', error && 'hp-radiocards--error', className)} aria-describedby={error ? errorId : undefined}>
      <legend className="hp-radiocards__legend">
        {label}
        {labelNote && <span className="hp-radiocards__note"> {labelNote}</span>}
      </legend>
      <div className={cx('hp-radiocards__grid', `hp-radiocards__grid--${columns}`)}>
        {options.map((o) => {
          const checked = o.id === value
          return (
            <label key={o.id} className={cx('hp-radiocards__option', columns === 1 && 'hp-radiocards__option--row', checked && 'hp-radiocards__option--checked')}>
              <input type="radio" name={groupName} value={o.id} checked={checked} onChange={() => onChange(o.id)} className="hp-radiocards__input" />
              <span className="hp-radiocards__dot" aria-hidden="true" />
              <span className="hp-radiocards__label">{o.label}</span>
            </label>
          )
        })}
      </div>
      {error && (
        <div id={errorId} className="hp-radiocards__error" aria-live="polite">
          <Icon name="alert-triangle" size={18} />
          <span>{error}</span>
        </div>
      )}
    </fieldset>
  )
}
